<template>
  <div class="haulage-revenue-main">
    <!-- Left sidebar for date and filters -->
    <div class="left-container">
      <div class="section-loader" v-if="filterLoader">
        <div class="section-loader-text">{{sectionLoaderText}}</div>
      </div>
      <div class="date-section">
        <div style="flex-grow: 1;">
          <span>Ready for Billing Date</span>
          <DateTimePicker title="From" placeholder="From" :showTime="false" :value.sync="fromDate" />
          <DateTimePicker title="To" placeholder="To" :showTime="false" :value.sync="toDate" />
        </div>
        <button @click="refreshClicked">Refresh</button>
      </div>
      <div class="filter-table">
        <Filters class="customer-filter" title="Customer" :tableData="customerData" itemKey="Customer Code" itemDesc="Customer Name" @confirmClicked="filterCustConfirm"/>
        <Filters class="jobtype-filter" title="Job Type" :tableData="jobData" itemKey="JobType" itemDesc="Description" @confirmClicked="filterJobConfirm"/>
        <Filters class="tariffarea-filter" title="Tariff Area" :tableData="areaData" itemKey="Area Code" itemDesc="Description" @confirmClicked="filterAreaConfirm"/>
      </div>
    </div>
    <!-- Right section -->
    <div class="right-container">
      <!-- Top bar showing filter selections -->
      <div class="filtered-section">
        <div class="section-loader" v-if="filterLoader">
        <div class="section-loader-text">{{sectionLoaderText}}</div>
      </div>
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title-long">Ready for Billing Date</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ fromDateInfo }} to {{ toDateInfo }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title-long">Customer</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredCustomer.length == 0 ? 'All' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(', ')">{{ filteredCustomer.length == 0 ? 'All' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(',') }}</div>
          </div>
        </div>
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title">Job Type</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredJobType.length == 0 ? 'All' : filteredJobType.map((s) => { return s['JobType'] }).join(', ')">{{ filteredJobType.length == 0 ? 'All' : filteredJobType.map((s) => { return s['JobType'] }).join(',') }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Tariff Area</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredArea.length == 0 ? 'All' : filteredArea.map((s) => { return s['Area Code'].split(' ').join('') }).join(', ')">{{ filteredArea.length == 0 ? 'All' : filteredArea.map((s) => { return s['Area Code'].split(' ').join('') }).join(',') }}</div>
          </div>
        </div>
        <div class="refresh-section">
          <div v-if="!filterLoader">Last Refreshed : {{refreshDate}}</div>
        </div>
      </div>
    
    <!-- Top row charts -->
    <div class="chart-container">
      <div class="hms-chart-table" id="hms-chart-table">

        <div class="section-loader" v-if="revenueOverTimeLoader">
        <div class="section-loader-text">{{sectionLoaderText}}</div>
      </div>

        <div class="hms-chart-title">Revenue Over Time
          <img class="interactable-chart-indicator" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png"/>
        </div>
        <div class="legend-holder" id="legend-holder"></div>
        <div class ="legend-holder2" id="legend-holder2"></div>
        <div class="legend-holder3" id="legend-holder3"></div>
        <div class="legend-holder4" id="legend-holder4"></div>

        <div class="hms-chart-container">
          <div class="barlinechart-table" id="barlinechart-table">

          <div class="barlineChart-HMSSales ct-golden-section" id="barlineChart-HMSSales"></div>
          <div class="barline2Chart-HMSSales ct-golden-section" id="barline2Chart-HMSSales"></div>
          
        </div>
      </div>
      </div>
      
      <div class="hms-chart2-table" id="hms-chart2-table">
        <div class="section-loader" v-if="revenueOverTimeLoader">
        <div class="section-loader-text">{{sectionLoaderText}}</div>
      </div>
        <div class="hms-chart-title">Own vs Outsource
          <img class="interactable-chart-indicator" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png"/>
        </div>
        <div class="hms-chart-container">
          <div class="pie-chart-HMSSales" id="pie-chart-HMSSales"></div>
        </div>
      </div>

      <!-- Bottom row charts -->
      <div class="hms-chart3-table" id="hms-chart3-table">
        <div class="section-loader" v-if="top50CustomersLoader" style="align-items:flex-start;padding-top:25vh">
        <div class="section-loader-text">{{sectionLoaderText}}</div>
      </div>
        <div class="hms-chart-title">Top 50 Customers
          <img class="interactable-chart-indicator" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png"/>
        </div>
        <div class="hms-chart-container">
          <div class="barhor-chart-topCustomer ct-golden-section" id="barhor-chart-topCustomer"></div>
        </div>
      </div>

       <div class="hms-chart4-table" id="hms-chart4-table">
         <div class="section-loader" v-if="top50ShipConLoader" style="align-items:flex-start;padding-top:25vh">
        <div class="section-loader-text">{{sectionLoaderText}}</div>
      </div>
        <div class="hms-chart-title">Top 50 Shipper/Consignee
          <img class="interactable-chart-indicator" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png"/>
        </div>
        <div class="hms-chart-container">
          <div class="barhor-chart-topShipCon ct-golden-section" id="barhor-chart-topShipCon"></div>
        </div>
      </div>
      </div>
    </div>

    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="drillThroughClicked" ref="context"/>
    
    <!-- <Loader :isVisible.sync="loading" :loadingText="loadText" /> -->
  </div>
</template>

<script>
/* eslint-disable */
import Filters from '@/components/Filters.vue';
import ContextMenu from '@/components/ContextMenu.vue';
export default {
  components: {
    Filters, ContextMenu
  },
  props: {
    // loading: { type: Boolean, default: false },
    // loadText: { type: String, default: '' },

    // Set starting date 14 days prior of current date
    fromDate: { type: String, default: new Date((new Date()).valueOf() - 1000*3600*24*14)},
    toDate: { type: String, default: new Date()},
    fromDateInfo: { type: String, default: null },
    toDateInfo: { type: String, default: null },
    refreshDate: { type: String, default: new Date() },
    
    customerData: { type: Array, default: function() { return [] } },
    jobData: { type: Array, default: function() { return [] } },
    areaData: { type: Array, default: function() { return [] } },

    selectedCustomer: { type: Array, default: function() { return [] } },
    filteredCustomer: { type: Array, default: function() { return [] } },

    selectedJobType: { type: Array, default: function() { return [] } },
    filteredJobType: { type: Array, default: function() { return [] } },

    selectedArea: { type: Array, default: function() { return [] } },
    filteredArea: { type: Array, default: function() { return [] } },
    
    chartBar: { type: Object, default: function() { return null } },
    chartLine: { type: Object, default: function() { return null } },
    chartPie: { type: Object, default: function() { return null } },
    chartBarHor: { type: Object, default: function() { return null } },
    chartBarHor2: { type: Object, default: function() { return null } },

    hmsSalesByDay: {type: Array, default: function() { return [] } },
    hmsSalesByMonth: {type: Array, default: function() { return [] } },
    topCustomers: {type: Array, default: function() { return [] } },
    topShipCon: {type: Array, default: function() { return [] } },

    showContextMenu: { type: Boolean, default: false },
    contextItems: { type: Array, default: function() { return [] } },
    contextPosition: { type: Array, default: function() { return [ 100, 100 ] } },

    getCustomerCode: { type: String, default: '' },
    getJobType: { type: String, default: '' },
    getAreaCode: { type: String, default: '' },

    selectedJobTypeInfo: { type: String, default: '' },
    selectedAreaInfo: { type: String, default: '' },
    selectedCustomerInfo: { type: String, default: '' },

    filterLoader: { type: Boolean, default: false },
    revenueOverTimeLoader: { type: Boolean, default: false },
    top50CustomersLoader: { type: Boolean, default: false },
    top50ShipConLoader: { type: Boolean, default: false },
    sectionLoaderText: { type: String, default: 'Loading' },
  },
  methods: {
    filterCustConfirm: function(items) {
      this.selectedCustomer = items;
    },
    filterJobConfirm: function(items) {
      this.selectedJobType = items;
    },
    filterAreaConfirm: function(items) {
      this.selectedArea = items;
    },
    // Run when clicking refresh button
    refreshClicked: async function() {
      this.filterLoader = true;
      this.revenueOverTimeLoader = true;
      this.top50CustomersLoader = true;
      this.top50ShipConLoader = true;
      this.createChart();
    },
    // Upon selecting any drill through from context menu, set/clear session storage and route to drill through
    drillThroughClicked: async function(item) {
      if (item.includes('Top 50 Shipper/Consignee Details')){
        item = 'Top 50 Shipper Consignee Details';
      }
      sessionStorage.setItem(`Drill Through - DETAILS ${item}`, 
        JSON.stringify(
          { 
            fromDate: this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd'), 
            toDate: this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd'),
            selectedJobTypeInfo: this.selectedJobTypeInfo,
            selectedCustomerInfo: this.selectedCustomerInfo,
            selectedAreaInfo: this.selectedAreaInfo,
            getJobType: this.getJobType,
            getCustomerCode: this.getCustomerCode,
            getAreaCode: this.getAreaCode,
            lastRefresh: this.refreshDate,
            title: item
          }
        ));
      var drillThroughLink = this.$router.resolve(`/Home/${this.$route['params']['user']}/Dashboard/Haulage Revenue/Drill Through - DETAILS ${item}`);
      window.open(drillThroughLink.href, '_blank');
      sessionStorage.clear();
    },
    createChart: async function(){
      $('#barlineChart-HMSSales').html('');
      $('#barline2Chart-HMSSales').html('');
      $('#legend-holder').html('');
      $('#legend-holder2').html('');
      $('#legend-holder3').html('');
      $('#legend-holder4').html('');
      $('#pie-chart-HMSSales').html('');
      $('#barhor-chart-topCustomer').html('');
      $('#barhor-chart-topShipCon').html('');

      if (this.chartBar){
        this.chartBar.detach();
      }
      if (this.chartLine){
        this.chartLine.detach();
      }
      if (this.chartPie){
        this.chartPie.detach();
      }
      if (this.chartBarHor){
        this.chartBarHor.detach();
      }
      if (this.chartBarHor2){
        this.chartBarHor2.detach();
      }
      
      // Calculate the number of days between fromDate and toDate
      var timeDifference = this.toDate.getTime() - this.fromDate.getTime();
      var daysBetween = timeDifference / (1000 * 3600 * 24);

      this.fromDateInfo = this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd');
      this.toDateInfo = this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd');
      this.refreshDate = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');

      // Get filter values
      this.filteredCustomer = this.selectedCustomer;
      this.getCustomerCode = this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',');
      this.filteredJobType = this.selectedJobType;
      this.getJobType = this.filteredJobType.length == 0 ? '' : this.filteredJobType.map((c) => { return c['Job Type'] }).join(',');
      this.filteredArea = this.selectedArea;
      this.getAreaCode = this.filteredArea.length == 0 ? '' : this.filteredArea.map((c) => { return c['Area Code'] }).join(',');

      //Get filter values for drill through
      this.selectedCustomerInfo = this.filteredCustomer.length == 0 ? 'All' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',');
      this.selectedJobTypeInfo = this.filteredJobType.length == 0 ? 'All' : this.filteredJobType.map((c) => { return c['Job Type'] }).join(',');
      this.selectedAreaInfo = this.filteredArea.length == 0 ? 'All' : this.filteredArea.map((c) => { return c['Area Code'] }).join(',');

      this.filterLoader = false;

      // All charts APIs are calling simultaneously
      // Revenue Over Time chart
      if (daysBetween <= 31) {
        this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&datetype=RFB&rpttype=BY_DAY&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}`).then((result) => {
          this.hmsSalesByDay = result;
          this.generateRevenueOverTimeChartDay(this.hmsSalesByDay, daysBetween);
          this.revenueOverTimeLoader = false;
        });
      }
      else {
        this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&datetype=RFB&rpttype=BY_MONTH&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}`).then((result) => {
          this.hmsSalesByMonth = result;
          this.generateRevenueOverTimeChartMonth(this.hmsSalesByMonth);
          this.revenueOverTimeLoader = false;
        });
      }
      
      // Top 50 Customers
      this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&datetype=RFB&rpttype=BY_CUSTOMER&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`).then((result) => {
        this.topCustomers = result;
        this.generateTop50Customers(this.topCustomers);
        this.top50CustomersLoader = false;
      });

      // Top 50 Shipper/Consignee
      this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.$dateTime.getDateTime(this.fromDate, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.toDate, 'yyyy-MM-dd')}&datetype=RFB&rpttype=BY_SHPRCSGN&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`).then((result) => {
        this.topShipCon = result;
        this.generateTop50ShipCon(this.topShipCon);
        this.top50ShipConLoader = false;
      });
    },
    // Generate Revenue Over Time Chart by Day as x-axis (within 14 days and 1 month)
    generateRevenueOverTimeChartDay: async function(data, daysBetween){
      if(data.includes('error')){
        document.getElementById('barlineChart-HMSSales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      }
      else if(data.length == 0){
        document.getElementById('barlineChart-HMSSales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      }
      else if (daysBetween <= 14){
        var dynamicSeriesName = Object.keys(data[0]).filter((o) => { return  o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtTotal' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
        var dynamicSeries = dynamicSeriesName.map((d) => {
          return {
            name: d,
            data: data.map((p) => { return p[d] })
          }
        });
        var value = dynamicSeriesName.map((d) => {
          return {
            data: Math.max(...data.map((p) => { return p[d] })),
            data1: Math.min(...data.map((p) => { return p[d] }))
          }
        })
        var maxValue = Math.max(...value.map((p) => { return p.data }));
        var minValue = Math.min(...value.map((p) => { return p.data1 }));
        var dynamicSeriesName2 = Object.keys(data[0]).filter((o) => { return o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'AmtTotal' &&  o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
        var dynamicSeries2 = dynamicSeriesName2.map((d) => {
            return {
              name: d,
              data: data.map((p) => { return p[d] })
            }
        });
        var value2 = dynamicSeriesName2.map((d) => {
            return {
              data: Math.max(...data.map((p) => { return p[d] })),
              data1: Math.min(...data.map((p) => { return p[d] }))
            }
          });
        var maxValue2 = Math.max(...value2.map((p) => { return p.data }));
        var minValue2 = Math.min(...value2.map((p) => { return p.data1 }));
        var maxValueTopChart = Math.max(maxValue, maxValue2);
        var minValueTopChart = Math.min(minValue, minValue2);
      
      var legendsChart1 = document.getElementById('legend-holder');
      var legendsChart2 = document.getElementById('legend-holder2');
      this.chartBar = new Chartist.Bar('.barlineChart-HMSSales', {
          labels: data.map((m) => { return m['XAxis'] }),
          series: dynamicSeries
      }, {
          chartPadding: {top: 10,right: 20,bottom: 20,left: 20},
          fullWidth: true,  
          high: maxValueTopChart,
          low: minValueTopChart,
          seriesBarDistance: 10,
          axisY: {offset: 30, scaleMinSpace: 20,showLabel: true},
          plugins: [ Chartist.plugins.legend( { legendNames: ['Haulage', 'Toll', 'FAF', 'DGC', 'Others'], position: legendsChart1, className: "barlineChart-HMSSales"} ) ]
      });
      this.chartLine = new Chartist.Line('.barline2Chart-HMSSales', {
            series: dynamicSeries2
          }, 
          {
          chartPadding: {top: 10,right: 40,bottom: 20,left: 50},
            fullWidth: true, 
            high: maxValue2, 
            low: minValue2,
            axisY: {offset: -4, scaleMinSpace: 20, showLabel: true, showGrid: false, position:'end'},
            axisX: {showGrid: false},
            plugins: [ Chartist.plugins.legend( { legendNames: ['20ft','40ft'], position: legendsChart2, className: "barline2Chart-HMSSales"} ) ]
          });

      if(data.includes('error'))
        document.getElementById('pie-chart-HMSSales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      else if(data.length == 0)
        document.getElementById('pie-chart-HMSSales').innerHTML = "<div style=\"padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      else{
        var dynamicSeriesName3 = Object.keys(data[0]).filter((o) => { return o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'AmtTotal' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' });
        var dynamicSeries3 = dynamicSeriesName3.map((d) => {
          return {
            name: d,
            data: data.map((p) => { return p[d] }).reduce((a, b) => a + b, 0)
          }
        });

        var series3Array = [dynamicSeries3[0].data, dynamicSeries3[1].data];

        var sum = function(a, b) {
          return a + b
        };

        var data = { series: series3Array }

        this.chartPie = new Chartist.Pie('.pie-chart-HMSSales', data, { 
          labelInterpolationFnc: function(value) {
            var percentage = Math.round(value / series3Array.reduce(sum) * 100) + '%';
            return percentage;
          },
          fullWidth: true,
          showLabel: true,
          plugins: [ Chartist.plugins.legend( { legendNames: ['Own', 'Outsource'], position: 'bottom', className: "pie-chart-HMSSales", clickable: false} ) ],
        });
      }
    }
    else if (daysBetween <= 31) {
      var dynamicSeriesName = Object.keys(data[0]).filter((o) => { return  o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
        var dynamicSeries = dynamicSeriesName.map((d) => {
          return {
            name: d,
            data: data.map((p) => { return p[d] })
          }
        });
        var value = dynamicSeriesName.map((d) => {
          return {
            data: Math.max(...data.map((p) => { return p[d] })),
            data1: Math.min(...data.map((p) => { return p[d] }))
          }
        })
        var maxValue = Math.max(...value.map((p) => { return p.data }));
        var minValue = Math.min(...value.map((p) => { return p.data1 }));
        var dynamicSeriesName2 = Object.keys(data[0]).filter((o) => { return o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'AmtTotal' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
        var dynamicSeries2 = dynamicSeriesName2.map((d) => {
            return {
              name: d,
              data: data.map((p) => { return p[d] })
            }
        });
        var value2 = dynamicSeriesName2.map((d) => {
            return {
              data: Math.max(...data.map((p) => { return p[d] })),
              data1: Math.min(...data.map((p) => { return p[d] }))
            }
          });
        var maxValue2 = Math.max(...value2.map((p) => { return p.data }));
        var minValue2 = Math.min(...value2.map((p) => { return p.data1 }));
        var maxValueTopChart = Math.max(maxValue, maxValue2);
        var minValueTopChart = Math.min(minValue, minValue2);
      
      var legendsChart1 = document.getElementById('legend-holder3');
      var legendsChart2 = document.getElementById('legend-holder4');
      this.chartBar = new Chartist.Bar('.barlineChart-HMSSales', {
          labels: data.map((m) => { return m['XAxis'] }),
          series: dynamicSeries
      }, {
          chartPadding: {top: 10,right: 20,bottom: 20,left: 20},
          fullWidth: true,  
          high: maxValueTopChart,
          low: minValueTopChart,
          seriesBarDistance: 10,
          axisY: {offset: 30, scaleMinSpace: 20,showLabel: true},
          plugins: [ Chartist.plugins.legend( { legendNames: ['Total Revenue'], position: legendsChart1, className: "barlineChart-HMSSales"} ) ]
      });
      
      this.chartLine = new Chartist.Line('.barline2Chart-HMSSales', {
            series: dynamicSeries2
          }, 
          {
          chartPadding: {top: 10,right: 40,bottom: 20,left: 50},
            fullWidth: true, 
            high: maxValue2, 
            low: minValue2,
            axisY: {offset: -4, scaleMinSpace: 20, showLabel: true, showGrid: false, position:'right'},
            axisX: {showGrid: false},
            plugins: [ Chartist.plugins.legend( { legendNames: ['Total Container'], position: legendsChart2, className: "barline2Chart-HMSSales"} ) ]
          });

      if(data.includes('error'))
        document.getElementById('pie-chart-HMSSales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      else if(data.length == 0)
        document.getElementById('pie-chart-HMSSales').innerHTML = "<div style=\"padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      else{
        var dynamicSeriesName3 = Object.keys(data[0]).filter((o) => { return o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'AmtTotal' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' });
        var dynamicSeries3 = dynamicSeriesName3.map((d) => {
          return {
            name: d,
            data: data.map((p) => { return p[d] }).reduce((a, b) => a + b, 0)
          }
        });

        var series3Array = [dynamicSeries3[0].data, dynamicSeries3[1].data];

        var sum = function(a, b) {
          return a + b
        };

        var data = { series: series3Array }

        this.chartPie = new Chartist.Pie('.pie-chart-HMSSales', data, { 
          labelInterpolationFnc: function(value) {
            var percentage = Math.round(value / series3Array.reduce(sum) * 100) + '%';
            return percentage;
          },
          fullWidth: true,
          showLabel: true,
          plugins: [ Chartist.plugins.legend( { legendNames: ['Own', 'Outsource'], position: 'bottom', className: "pie-chart-HMSSales", clickable: false} ) ],
        });
      }
    }
    if (this.chartLine){
      var $tooltip = $('<div class="tooltip tooltip-hidden" style="z-index:6"></div>').appendTo($('.barline2Chart-HMSSales'));
      $(document).on('mouseenter', '.ct-point', function() {
        var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');
        $tooltip.html("<span>" + seriesName + "<br/> " + value);
        $tooltip.removeClass('tooltip-hidden');
      });
      $(document).on('mouseleave', '.ct-point', function() {
        $tooltip.addClass('tooltip-hidden');
      });
      $(document).on('mousemove', '.ct-point', function(event) {
        $tooltip.css({
          left: event.pageX - 390,
          top: event.pageY - 210
        });
      });
    }

    var mainContainer = this;
      $('document').ready(() => {
        $(document).on('click', '.barline2Chart-HMSSales .ct-point', function(e) {
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'Daily Revenue Details' ];
          
          mainContainer.$nextTick(() => {
            console.log(mainContainer.$refs.context);
            console.log(mainContainer.$refs.context.$el);
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 50), e.clientX + 15];
          });
        });
      });
      $('document').ready(() => {
        $(document).on('click', '.pie-chart-HMSSales .ct-slice-pie', function(e) {
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'Own and Outsource Details' ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 40), e.clientX + 15];
          });
        });
      });
    },

    // Generate Revenue Over Time Chart by Month as x-axis (more than 1 month)
    generateRevenueOverTimeChartMonth: async function(data){
      if(data.includes('error')){
        document.getElementById('barlineChart-HMSSales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      }
      else if(data.length == 0){
        document.getElementById('barlineChart-HMSSales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      }
      else {
        var dynamicSeriesName = Object.keys(data[0]).filter((o) => { return  o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
          var dynamicSeries = dynamicSeriesName.map((d) => {
            return {
              name: d,
              data: data.map((p) => { return p[d] })
            }
          });
          var value = dynamicSeriesName.map((d) => {
            return {
              data: Math.max(...data.map((p) => { return p[d] })),
              data1: Math.min(...data.map((p) => { return p[d] }))
            }
          })
          var maxValue = Math.max(...value.map((p) => { return p.data }));
          var minValue = Math.min(...value.map((p) => { return p.data1 }));
          var dynamicSeriesName2 = Object.keys(data[0]).filter((o) => { return o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'AmtTotal' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalContOwn' && o != 'TotalContOutsourced' && o != 'AmtTotalOwn' && o != 'AmtTotalOutsourced' });
          var dynamicSeries2 = dynamicSeriesName2.map((d) => {
              return {
                name: d,
                data: data.map((p) => { return p[d] })
              }
          });
          var value2 = dynamicSeriesName2.map((d) => {
              return {
                data: Math.max(...data.map((p) => { return p[d] })),
                data1: Math.min(...data.map((p) => { return p[d] }))
              }
            });
          var maxValue2 = Math.max(...value2.map((p) => { return p.data }));
          var minValue2 = Math.min(...value2.map((p) => { return p.data1 }));
          var maxValueTopChart = Math.max(maxValue, maxValue2);
          var minValueTopChart = Math.min(minValue, minValue2);
          
          var legendsChart1 = document.getElementById('legend-holder3');
          var legendsChart2 = document.getElementById('legend-holder4');
          this.chartBar = new Chartist.Bar('.barlineChart-HMSSales', {
              labels: data.map((m) => { return m['XAxisDesc'] }),
              series: dynamicSeries
          }, {
              chartPadding: {top: 10,right: 20,bottom: 20,left: 20},
              fullWidth: true,  
              high: maxValueTopChart,
              low: minValueTopChart,
              seriesBarDistance: 10,
              axisY: {offset: 30, scaleMinSpace: 20, showLabel: true},
              plugins: [ Chartist.plugins.legend( { legendNames: ['Total Revenue'], position: legendsChart1, className: "barlineChart-HMSSales"} ) ]
          });
          this.chartLine = new Chartist.Line('.barline2Chart-HMSSales', {
                series: dynamicSeries2
              }, 
              {
              chartPadding: {top: 10,right: 40,bottom: 20,left: 50},
                fullWidth: true, 
                high: maxValue2, 
                low: minValue2,
                axisY: {offset: -4, scaleMinSpace: 20, showLabel: true, showGrid: false, position:'right'},
                axisX: {showGrid: false},
                plugins: [ Chartist.plugins.legend( { legendNames: ['Total Container'], position: legendsChart2, className: "barline2Chart-HMSSales"} ) ]
              });

          if(data.includes('error'))
            document.getElementById('pie-chart-HMSSales').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
          else if(data.length == 0)
            document.getElementById('pie-chart-HMSSales').innerHTML = "<div style=\"padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
          else{
            var dynamicSeriesName3 = Object.keys(data[0]).filter((o) => { return o != '#' && o != 'XAxis' && o != 'XAxisDesc' && o != 'AmtCHC' && o != 'AmtREB' && o != 'AmtCHCAfterREB' && o != 'AmtTOL' && o != 'AmtFAF' && o != 'AmtDGC' && o != 'AmtOTH' && o != 'AmtTotal' && o != 'Total20Ft' && o != 'Total40Ft' && o != 'TotalTEUs' && o != 'AmtBilled' && o != 'TotalCont' && o != 'TotalContOwn' && o != 'TotalContOutsourced' });
            var dynamicSeries3 = dynamicSeriesName3.map((d) => {
              return {
                name: d,
                data: data.map((p) => { return p[d] }).reduce((a, b) => a + b, 0)
              }
            });

            var series3Array = [dynamicSeries3[0].data, dynamicSeries3[1].data];

            var sum = function(a, b) {
              return a + b
            };

            var data = { series: series3Array }

            this.chartPie = new Chartist.Pie('.pie-chart-HMSSales', data, { 
              labelInterpolationFnc: function(value) {
                var percentage = Math.round(value / series3Array.reduce(sum) * 100) + '%';
                return percentage;
              },
              fullWidth: true,
              showLabel: true,
              plugins: [ Chartist.plugins.legend( { legendNames: ['Own', 'Outsource'], position: 'bottom', className: "pie-chart-HMSSales", clickable: false} ) ],
            });
          }
        }
        if (this.chartLine){
          var $tooltip = $('<div class="tooltip tooltip-hidden" style="z-index:6"></div>').appendTo($('.barline2Chart-HMSSales'));
          $(document).on('mouseenter', '.ct-point', function() {
            var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');
            $tooltip.html("<span>" + seriesName + "<br/> " + value);
            $tooltip.removeClass('tooltip-hidden');
          });
          $(document).on('mouseleave', '.ct-point', function() {
            $tooltip.addClass('tooltip-hidden');
          });
          $(document).on('mousemove', '.ct-point', function(event) {
            $tooltip.css({
              left: event.pageX - 390,
              top: event.pageY - 210
            });
          });
        }

        var mainContainer = this;
          $('document').ready(() => {
            $(document).on('click', '.barline2Chart-HMSSales .ct-point', function(e) {
              mainContainer.showContextMenu = true;
              mainContainer.contextItems = [ 'Daily Revenue Details' ];
              
              mainContainer.$nextTick(() => {
                mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 0), e.clientX + 15];
              });
            });
          });

          $('document').ready(() => {
            $(document).on('click', '.pie-chart-HMSSales .ct-slice-pie', function(e) {
              mainContainer.showContextMenu = true;
              mainContainer.contextItems = [ 'Own and Outsource Details' ];
              
              mainContainer.$nextTick(() => {
                mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 35), e.clientX + 15];
              });
            });
          });
    },

    // Top 50 Customers Horizontal Bar Chart 
    generateTop50Customers: async function(data){
      if(data.includes('error'))
        document.getElementById('barhor-chart-topCustomer').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      else if(data.length == 0)
        document.getElementById('barhor-chart-topCustomer').innerHTML = "<div style=\"padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      else{
        var formatCurrency = new Intl.NumberFormat();
        var currencyUnit = data[0]['Currency'];

        var dynamicSeriesName4 = Object.keys(data[0]).filter((o) => { return o != 'customer_ranking' && o != 'Customer' && o != 'Currency'});
        var dynamicSeries4 = dynamicSeriesName4.map((d) => {
          return {
            name: d,
            data: data.map((p) => { return p[d] })
          }
        });

        //Top Customers Horizontal Bar Height
        var barHorHeightCus;
        if (data.length <= 7)
          barHorHeightCus = 280;
        else if (data.length <= 15)
          barHorHeightCus = 500;
        else if (data.length <= 23)
          barHorHeightCus = 750;
        else if (data.length <= 41)
          barHorHeightCus = 1000;
        else
          barHorHeightCus = 1300;

        this.chartBarHor = new Chartist.Bar('.barhor-chart-topCustomer', {
          labels: data.map(c => {return c["Customer"];}),
          series: dynamicSeries4
        },
        {
          chartPadding: {top: 20,right: 0,bottom: 0,left: 20},
          height: barHorHeightCus,
          fullWidth: true,
          reverseData: true,
          horizontalBars: true,
          axisY: {offset: 180},
          axisX: {scaleMinSpace: 50},
          plugins: [ Chartist.plugins.ctPointLabels( { textAnchor: 'start', labelInterpolationFnc: function(value) {return currencyUnit + formatCurrency.format(value.toFixed(2)) } } ) ]
        });
        $("#barhor-chart-topCustomer").css('height', barHorHeightCus);
      }
      var mainContainer = this;
      $('document').ready(() => {
        $(document).on('click', '.barhor-chart-topCustomer .ct-series-a .ct-bar', function(e) {
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'Top 50 Customers Details' ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 40), e.clientX + 15];
          });
        });
      });
    },

    // Top 50 Shipper/Consignee Horizontal Bar Chart
    generateTop50ShipCon: async function(data){
      if(data.includes('error'))
      document.getElementById('barhor-chart-topShipCon').innerHTML = "<div style=\"padding-top: 100px; text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
    else if(data.length == 0)
      document.getElementById('barhor-chart-topShipCon').innerHTML = "<div style=\"padding-top: 150px; text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
    else{
      var formatCurrency = new Intl.NumberFormat();
      var currencyUnit = data[0]['Currency'];

      var dynamicSeriesName5 = Object.keys(data[0]).filter((o) => { return o != 'customer_ranking' && o != 'Shipper/Consignee' && o != 'Currency'});
      var dynamicSeries5 = dynamicSeriesName5.map((d) => {
        return {
          name: d,
          data: data.map((p) => { return p[d] })
        }
      });

      //Top Shipper/Consignee Horizontal Bar Height
      var barHorHeightShipCon;
      if (data.length <= 7)
        barHorHeightShipCon = 280;
      else if (data.length <= 15)
        barHorHeightShipCon = 500;
      else if (data.length <= 23)
        barHorHeightShipCon = 750;
      else if (data.length <= 41)
        barHorHeightShipCon = 1000;
      else
        barHorHeightShipCon = 1300;

      this.chartBarHor2 = new Chartist.Bar('.barhor-chart-topShipCon', {
        labels: data.map(c => {return c["Shipper/Consignee"];}),
        series: dynamicSeries5
      },
      {
        chartPadding: {top: 20,right: 0,bottom: 0,left: 20},
        height: barHorHeightShipCon,
        fullWidth: true,
        reverseData: true,
        horizontalBars: true,
        axisY: {offset: 180},
        axisX: {scaleMinSpace: 50},
        plugins: [ Chartist.plugins.ctPointLabels( { textAnchor: 'start', labelInterpolationFnc: function(value) {return currencyUnit + formatCurrency.format(value.toFixed(2)) } } ) ]
      });
        $("#barhor-chart-topShipCon").css('height', barHorHeightShipCon);
    }
    var mainContainer = this;
    $('document').ready(() => {
      $(document).on('click', '.barhor-chart-topShipCon .ct-series-a .ct-bar', function(e) {
        mainContainer.showContextMenu = true;
        mainContainer.contextItems = [ 'Top 50 Shipper/Consignee Details', 'Monthly Total Containers by Shipper', 'Monthly Total Containers by Consignee' ];
        
        mainContainer.$nextTick(() => {
          mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 60), e.clientX + 15];
        });
      });
    });
    },
  },
  async mounted() {
    this.filterLoader = true;
    this.revenueOverTimeLoader = true;
    this.top50CustomersLoader = true;
    this.top50ShipConLoader = true;
    this.customerData = await this.$apiCallV2('/HaulageRevenue/GetListMaster?masterFile=BILLCUSTNAME');
    this.loadText = 'Getting Job Types';
    this.jobData = await this.$apiCallV2(`/HaulageRevenue/GetListMaster?masterFile=SYSTEM_JOBTYPE&module=HMS`);
    this.loadText = 'Getting Tariff Area';
    this.areaData = await this.$apiCallV2('/HaulageRevenue/GetListMaster?masterFile=area');
    this.createChart();
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
@media print, screen and (min-width: 1290px){
  .haulage-revenue-main{
    display: flex;
    padding: 5px 45px;
    width: 100%;
    height: 100%;
    font-size: 12px;
    overflow-x: hidden;
    > .left-container{
      height: 100%;
      min-width: 300px;
      max-width: 300px;
      background-color: white;
      border-radius: 5px;
      margin-right: 5px;
      position: relative;
      overflow: hidden;
      > .date-section{
        height: 80px;
        display: flex;
        align-items: center;
        padding: 10px 5px 0 5px;
      }
      
      > .filter-table{
        width: 100%; 
        height: calc( 100% - 125px); 
        flex-grow: 1;
        >.customer-filter{
          width: 100%; 
          height: calc( 100% - 67%);
          padding: 5px 5px 0 5px;
        }
        >.jobtype-filter{
          width: 100%; 
          height: 33%;
          padding: 0 5px 0 5px; 
        }
        >.tariffarea-filter{
          width: 100%; 
          height: 33%;
          padding: 0 5px 0 5px;   
        }
      }
    }
    > .right-container{
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      > .filtered-section {
        width: 100%;  
        height: auto;
        background-color: white;
        border-radius: 5px;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 8;
        display: flex;
        align-items: center;
        margin-bottom: 3px;
        overflow-x: auto;
        overflow-y: hidden;
        > .filtered-items {
          width: calc(100% - 250px);
          > .filtered-row {
            display: flex;
            align-items: center;
            > .filter-title-long {
            width: 270px;
            padding-left:3px;
            }
            > .filter-title {
              width: 120px;
              padding-left:3px;
            }
            > .colon-separator {
              margin: 0 5px;
            }
            > .filter-details {
              width: 100%;
            }
          }
        }
        
        > .refresh-section {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          margin-right: 3px;
        }
      }
    }
    .chart-container{
      display: flex;
      flex-wrap: wrap;
      height: calc(100% - 53.5% );
      width: 100%;
      justify-content: center;
      padding-bottom:3px;
    }
    .barlinechart-table{
      min-width: 100%;
      max-width: 100%;
      height: 85%;
      position: relative;
      margin-top:-5px;
    }
    .barlineChart-HMSSales{
      width: 100%;
      height: 100%;
      font-size: 10px;
      color: black;
    }
    .barline2Chart-HMSSales{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
    }
    .hms-chart-table{
      flex-grow: 1;
      min-width: 65%;
      max-width: 100%;
      margin: 0 0 4px 0;
      background-color: white;
      border-radius: 5px;
      height: 100%;
      position: relative;
    }
    .hms-chart2-table{
      flex-grow: 1;
      min-width: 30%;
      max-width: 100%;
      margin: 0 0 4px 4px;
      background-color: white;
      border-radius: 5px;
      height: 100%;
      position: relative;
    }
    .hms-chart3-table{
      flex-grow: 1;
      min-width: 45%;
      max-width: 100%;
      margin: 0 0 4px 0;
      background-color: white;
      border-radius: 5px;
      position: relative;
    }
    .hms-chart4-table{
      flex-grow: 1;
      min-width: 45%;
      max-width: 100%;
      margin: 0 0 4px 4px;
      background-color: white;
      border-radius: 5px;
      position: relative;
    }  
    .hms-chart-title{
      height: auto;
      width:  calc( 100% - 10px);
      margin-left: 10px;
      font-size: 12px;
      color: black;
      font-weight: bold;
      >.interactable-chart-indicator {
        height: 22px;
        width: 22px;
        position: absolute;
        top: 3px;
        right: 3px;
      }
    }
    .hms-chart-container{
      width: 100%;
      height: 90%;
      display: flex;
      padding-left:3px;
      padding-right:3px;
      padding-top:5px;
    }
    .pie-chart-HMSSales{
      margin-top:-10px;
      width:100%;
      height: 100%;
    }
    .barhor-chart-topCustomer{
      width: 100%;
      height: auto;
      font-size: 10px;
      color: black;
    }
    .barhor-chart-topShipCon{
      width: 100%;
      height: auto;
      font-size: 10px;
      color: black;
    }
    .legend-holder {
      width:85%;
      height:20px;
      margin-top:5px;
      padding-left:3px;
    }

    .legend-holder2 {
      width:40%;
      margin-right:-13.5%;
      float:right;
      height:20px;
      margin-top:-5px;
    }

    .legend-holder3 {
      width:25%;
      float:left;
      height:20px;
      margin-top:-10px;
      padding-left:3px;
    }

    .legend-holder4 {
      width:35%;
      margin-right:-40%;
      float:right;
      height:20px;
      margin-top:-10px;
    }
    // CSS for section loaders for section loading
    .section-loader {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #0004;
      z-index: 1000;

      > .section-loader-text {
        width: auto;
        height: 30px;
        padding: 10px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 8px #0004;
        user-select: none;
      }
    }
  }
}

@media print, screen and (max-width: 1290px) {
  .haulage-revenue-main{
  display: flex;
  padding: 5px 45px;
  width: 100%;
  height: 100%;
  font-size: 12px;
  overflow-x: hidden;
  > .left-container{
    height: 100%;
    min-width: 300px;
    max-width: 300px;
    background-color: white;
    border-radius: 5px;
    margin-right: 5px;
    position: relative;
    overflow: hidden;
    > .date-section{
      height: 80px;
      display: flex;
      align-items: center;
      padding: 10px 5px 0 5px;
    }
    
    > .filter-table{
      width: 100%; 
      height: calc( 100% - 125px); 
      flex-grow: 1;
      >.customer-filter{
        width: 100%; 
        height: calc( 100% - 67%);
        padding: 5px 5px 0 5px;
      }
      >.jobtype-filter{
        width: 100%; 
        height: 33%;
        padding: 5px 5px 0 5px; 
      }
      >.tariffarea-filter{
        width: 100%; 
        height: 33%;
        padding: 5px 5px 0 5px;  
      }
      }
    }
    > .right-container{
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      > .filtered-section {
        width: 100%;  
        height: auto;
        background-color: white;
        border-radius: 5px;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 8;
        display: flex;
        align-items: center;
        margin-bottom: 3px;
        overflow-x: auto;
        overflow-y: hidden;
        > .filtered-items {
          width: calc(100% - 250px);
          > .filtered-row {
            display: flex;
            align-items: center;
            > .filter-title-long {
            width: 270px;
            padding-left:3px;
            }
            > .filter-title {
              width: 120px;
              padding-left:3px;
            }
            > .colon-separator {
              margin: 0 5px;
            }
            > .filter-details {
              width: 100%;
            }
          }
        }
        
        > .refresh-section {
          height: 100%;
          min-width: 250px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          margin-right: 3px;
        }
      }
    }
    .chart-container{
      display: flex;
      flex-wrap: wrap;
      height: calc(100% - 53.5% );
      width: 100%;
      justify-content: center;
      padding-bottom:3px;
    }
    .barlinechart-table{
      min-width: 100%;
      max-width: 100%;
      height: 85%;
      position: relative;
      margin-top:-5px;
    }
    .barlineChart-HMSSales{
      width: 100%;
      height: 100%;
      font-size: 10px;
      color: black;
    }
    .barline2Chart-HMSSales{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
    }
    .hms-chart-table{
      flex-grow: 1;
      width:100%;
      margin: 0 0 4px 0;
      background-color: white;
      border-radius: 5px;
      height: 100%;
      position: relative;
    }
    .hms-chart2-table{
      flex-grow: 1;
      width: 100%;
      margin: 0 0 4px 0;
      background-color: white;
      border-radius: 5px;
      height: 100%;
      position: relative;
    }
    .hms-chart3-table{
      flex-grow: 1;
      width: 100%;
      margin: 0 0 4px 0;
      background-color: white;
      border-radius: 5px;
      position: relative;
    }
    .hms-chart4-table{
      flex-grow: 1;
      width: 100%;
      margin: 0 0 4px 0;
      background-color: white;
      border-radius: 5px;
      position: relative;
    }  
    .hms-chart-title{
      height: auto;
      width:  calc( 100% - 10px);
      margin-left: 10px;
      font-size: 12px;
      color: black;
      font-weight: bold;
      >.interactable-chart-indicator {
        height: 22px;
        width: 22px;
        position: absolute;
        top: 3px;
        right: 3px;
      }
    }
    .hms-chart-container{
      width: 100%;
      height: 90%;
      display: flex;
      padding-left:3px;
      padding-right:3px;
      padding-top:5px;
    }
    .pie-chart-HMSSales{
      margin-top:-10px;
      width:100%;
      height: 100%;
    }
    .barhor-chart-topCustomer{
      width: 100%;
      height: 100%;
      font-size: 10px;
      color: black;
    }
    .barhor-chart-topShipCon{
      width: 100%;
      height: 100%;
      font-size: 10px;
      color: black;
    }
    .legend-holder {
      width:85%;
      height:20px;
      margin-top:5px;
      padding-left:3px;
    }
    .legend-holder2 {
      width:40%;
      margin-right:-13.5%;
      float:right;
      height:20px;
      margin-top:-5px;
    }
    .legend-holder3 {
      width:25%;
      float:left;
      height:20px;
      margin-top:-10px;
      padding-left:3px;
    }
    .legend-holder4 {
      width:35%;
      margin-right:-40%;
      float:right;
      height:20px;
      margin-top:-10px;
    }
    // CSS for section loaders for section loading
    .section-loader {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #0004;
      z-index: 1000;

      > .section-loader-text {
        width: auto;
        height: 30px;
        padding: 10px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 8px #0004;
        user-select: none;
      }
    }
  }
}
</style>